import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendEVACDeviceProvider from "./baseProviders/amendEVACDeviceProvider"
import useContinueEVACDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEVACDeviceDraft"

interface IContinueEVACDeviceAmendmentUrlParams {
    deviceRef: string
}

interface IContinueEVACDeviceAmendmentProviderProps {
    children: ReactNode
}

const ContinueEVACDeviceAmendmentProvider = ({
    children,
}: IContinueEVACDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEVACDeviceAmendmentUrlParams
    >() as IContinueEVACDeviceAmendmentUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueAmendmentError,
        attachmentUUID,
        apiResSystemRef,
    } = useContinueEVACDeviceDraft(urlDeviceRef)

    return (
        <AmendEVACDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueAmendmentError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={apiResSystemRef ?? "Not loaded"}
        >
            {children}
        </AmendEVACDeviceProvider>
    )
}

export default ContinueEVACDeviceAmendmentProvider
